import Export from '__core/shared/model/export/Export';
import exportDataController from './exportData.controller';

export default angular
  .module('st.Export', ['st.Core', 'angular-cache'])
  .factory('Export', () => Export)
  .controller('exportDataController', exportDataController)
  .service(
    'exportService',
    ($window, $http, $rootScope, CacheFactory, dataService, uiService, Export, EXPORT) => {
      let cache;
      if (!CacheFactory.get(EXPORT.CACHE.NAME)) {
        cache = CacheFactory(EXPORT.CACHE.NAME, EXPORT.CACHE.STORE);
      }
      const cacheKey = (params, requestName) =>
        JSON.stringify({
          idAccount: $rootScope.CurrentAccount.id,
          idOrganization: $rootScope.CurrentOrganization.id,
          type: requestName || EXPORT.CACHE.NAME,
          params
        });
      return {
        clearCache: () => cache.removeAll(),
        create: (params) =>
          dataService.apiRequest(null, null, true, null, $http.get, EXPORT.API.CREATE, {
            params
          }),
        downloadUrl: (params) => {
          dataService
            .apiRequest(null, null, true, null, $http.get, EXPORT.API.DOWNLOAD_URL, {
              params
            })
            .then((res) => {
              if (res && res.status) {
                uiService.toast({
                  text: {
                    p1: 'Initializing',
                    p2: 'export',
                    p3: 'download'
                  },
                  progress: true
                });
                $window.location.href = res.url;
              } else {
                uiService.toast({
                  text: {
                    p1: 'Failed to',
                    p2: 'retrieve',
                    p3: 'export URL'
                  },
                  warn: true
                });
              }
            });
        },
        getAvailable: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'getAvailable'),
            params?.ignoreCache === true,
            Export.build,
            $http.get,
            EXPORT.API.AVAILABLE,
            { params }
          ),
        getQueue: (params) =>
          dataService.apiRequest(null, null, true, null, $http.get, EXPORT.API.QUEUE, {
            params
          })
      };
    }
  )
  .constant('EXPORT', {
    API: {
      CREATE: '/api/v1/export/create/',
      QUEUE: '/api/v1/export/queue/',
      DOWNLOAD_URL: '/api/v1/export/download-url/',
      AVAILABLE: '/api/v1/exports/available/'
    },
    FIELDS: {
      LIST: {
        list: [
          'id',
          'size',
          'idAccount',
          'accountInformation',
          'accessHistory',
          'timeStamp',
          'completedTimeStamp',
          'isActive'
        ]
      }
    },
    CACHE: {
      NAME: 'exportsCache',
      STORE: {
        maxAge: 60 * 1000,
        deleteOnExpire: 'aggressive',
        recycleFreq: 30 * 1000,
        storageMode: 'sessionStorage'
      }
    }
  });
